import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/internal_employees',
    name: 'InternalEmployee',
    component: {
      name: 'AdminInternalEmployee',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'internal_employee',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminInternalEmployeeIndex',
        component: () => import('../views/InternalEmployeeIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminInternalEmployeeNew',
        component: () => import('../views/InternalEmployeeInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminInternalEmployeeIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminInternalEmployeeShow',
        component: () => import('../views/InternalEmployeeShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminInternalEmployeeIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminInternalEmployeeDetails',
            component: () => import('../views/InternalEmployeeDetails.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminInternalEmployeeEdit',
            component: () => import('../views/InternalEmployeeInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInternalEmployeeDetails' },
            },
          },
          {
            path: 'managers',
            name: 'AdminInternalEmployeeManagers',
            component: () => import('../views/manager/InternalEmployeeManagers.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'manager',
            },
          },
          {
            path: 'certificates',
            name: 'AdminInternalEmployeeCetificates',
            component: () => import('../views/certificate/InternalEmployeeCertificates.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'certificate',
            },
          },
          {
            path: 'contracts',
            name: 'AdminInternalEmployeeContracts',
            component: () => import('../views/contract/InternalEmployeeContracts.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'contract',
            },
          },
          {
            path: 'hour_components',
            name: 'AdminInternalEmployeeHourComponents',
            component: () => import('../views/userHourComponent/UserHourComponentIndex.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'user_hour_component',
            },
          },

          /* ------- USER HOUR COMPONENTS ------- */
          {
            path: 'hour_components',
            name: 'AdminInternalEmployeeHourComponent',
            component: {
              name: 'AdminInternalEmployeeHourComponent',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'user_hour_component',
            },
            children: [
              {
                path: '',
                name: 'AdminInternalEmployeeHourComponentIndex',
                component: () => import('../views/userHourComponent/UserHourComponentIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminInternalEmployeeDetails' },
                },
              },
              {
                path: 'new',
                name: 'AdminInternalEmployeeHourComponentNew',
                component: () => import('../views/userHourComponent/UserHourComponentInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminInternalEmployeeHourComponent' },
                },
              },
              {
                path: ':userHourComponentId(\\d+)',
                name: 'AdminInternalEmployeeHourComponentShow',
                component: () => import('../views/userHourComponent/UserHourComponentShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminInternalEmployeeHourComponent',
                  },
                  tArgs: route => ({ name: route.params?.userHourComponentId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminInternalEmployeeHourComponentDetails',
                    component: () => import('../views/userHourComponent/UserHourComponentDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminInternalEmployeeHourComponentIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminInternalEmployeeHourComponentEdit',
                    component: () => import('../views/userHourComponent/UserHourComponentInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminInternalEmployeeHourComponentShow' },
                    },
                  },
                ]
              }
            ],
          },
          {
            path: 'settings',
            name: 'AdminInternalEmployeeSettings',
            component: () => import('../views/setting/InternalEmployeeSettingsDetails.vue'),
            meta: {
              backRoute: { name: 'AdminInternalEmployeeIndex' },
              resource: 'setting',
            },
          },
          {
            path: 'settings/edit',
            name: 'AdminInternalEmployeeSettingsEdit',
            component: () => import('../views/setting/InternalEmployeeSettingsInput.vue'),

            meta: {
              backRoute: { name: 'AdminInternalEmployeeSettings' },
              action: 'edit',
              resource: 'setting',
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));